import { render, staticRenderFns } from "./TitleDetail.vue?vue&type=template&id=6469b560"
import script from "./TitleDetail.vue?vue&type=script&lang=js"
export * from "./TitleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports